import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "header" }
const _hoisted_2 = { class: "title" }
const _hoisted_3 = { class: "description long" }
const _hoisted_4 = { class: "description long" }
const _hoisted_5 = { class: "description short" }

import {
  IonCard,
  IonCardHeader,
  IonCardContent,
  IonSkeletonText,
} from "@ionic/vue";

export default /*@__PURE__*/_defineComponent({
  __name: 'CardPortraitSkeleton',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(IonCard), { "data-test": "card-portrait-skeleton" }, {
    default: _withCtx(() => [
      _createVNode(_unref(IonCardHeader), null, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createVNode(_unref(IonSkeletonText), { animated: true })
          ])
        ]),
        _: 1
      }),
      _createVNode(_unref(IonCardContent), null, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_2, [
            _createVNode(_unref(IonSkeletonText), { animated: true })
          ]),
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_unref(IonSkeletonText), { animated: true })
          ]),
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_unref(IonSkeletonText), { animated: true })
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_unref(IonSkeletonText), { animated: true })
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})